"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTH_CONFIG = exports.HARDENED_AUTH_TENANT_IDS = void 0;
/** Tenant IDs for which hardened auth system is used. */
exports.HARDENED_AUTH_TENANT_IDS = [418];
/**
 * Parameters which determine how auth system operates.
 * All values are in milliseconds unless otherwise specified.
 */
exports.AUTH_CONFIG = {
    /**
     * Controls how often /auth/status endpoint will be polled by each client app.
     * Must be less than the token max ages, so that active sessions are kept alive.
     */
    STATUS_CHECK_INTERVAL: 60 * 1000,
    /**
     * Controls how long the client must idle before the warning prompt appears.
     * Used on all client applications for the idle timeout prompt.
     * Together with IDLE_DELAY_AFTER_PROMPT, should sum to SESSION_TOKEN_MAX_AGE.
     */
    IDLE_DELAY_BEFORE_PROMPT: 119 * 60 * 1000,
    /**
     * Controls how long the client has after idle prompt has appeared to extend their session.
     * Used on all client applications for the idle timeout prompt.
     * Together with IDLE_DELAY_BEFORE_PROMPT, should roughly sum to SESSION_TOKEN_MAX_AGE.
     */
    IDLE_DELAY_AFTER_PROMPT: 59 * 1000,
    /**
     * Controls how long the __session token persists, for hardened auth tenants.
     * Since the __session token is refreshed with each status check, this determines
     * how quickly authentication will expire when user is not active on app.
     */
    SESSION_TOKEN_MAX_AGE: 120 * 60 * 60 * 1000,
    /**
     * Controls how long the Cross Site Scripting Token (csst) persists, for all tenants.
     * Since the csst is not refreshed with status checks, this serves as an absolute timeout
     * such that users will need to re-login if this much time has passed after their last login.
     */
    CSS_TOKEN_MAX_AGE: '30d' // 30 days - uses format for https://github.com/auth0/node-jsonwebtoken
};
//# sourceMappingURL=config.js.map